"use client";
import React from "react";
import { Center, HStack } from "@chakra-ui/react";
import Image from "next/image";
import { Heading } from "@/elements";
import MicrosoftWImage from "public/microsoft365/microsoft-logo-wbg.png";
import SecurityComplianceTable from "@/views/pricing/components/tables/m365/securityBundles";
import MicrosoftServicesTable from "@/views/pricing/components/tables/m365/servicesBundles";
import { PRICING_HEADING_CONSTANTS } from "./constants";

export const tablist = [
  {
    component: <SecurityComplianceTable showHeading={false} />,
    label: () => (
      <Center>
        <HStack gap={3}>
          <Image
            src={MicrosoftWImage}
            alt="image"
            width="30"
            height="30"
            style={{
              objectFit: "contain",
            }}
          />
          <Heading fontWeight={600} variant={"subTitle3"}>
            {PRICING_HEADING_CONSTANTS.sec_bundles}
          </Heading>
        </HStack>
      </Center>
    ),
  },
  {
    component: <MicrosoftServicesTable showHeading={false} />,
    label: () => (
      <Center>
        <HStack gap={3}>
          <Image
            src={MicrosoftWImage}
            alt="image"
            width="30"
            height="30"
            style={{
              objectFit: "contain",
            }}
          />
          <Heading fontWeight={600} variant={"subTitle3"}>
            {PRICING_HEADING_CONSTANTS.services_bundles}
          </Heading>
        </HStack>
      </Center>
    ),
  },
];
